<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Circle Dashed" class="d-icon d-icon--circle-dashed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" d="M6.855 10.418a.5.5 0 0 1 .19.982 5.5 5.5 0 0 1-2.09 0 .5.5 0 0 1 .19-.982c.564.11 1.145.109 1.71 0Zm2.87-1.894a.5.5 0 0 1 .829.56 5.5 5.5 0 0 1-1.486 1.48.5.5 0 1 1-.557-.83 4.5 4.5 0 0 0 1.215-1.21Zm-8.154-.15a.5.5 0 0 1 .695.137 4.5 4.5 0 0 0 1.21 1.214.5.5 0 0 1-.561.829 5.5 5.5 0 0 1-1.48-1.486.5.5 0 0 1 .136-.693ZM1.187 4.56a.5.5 0 0 1 .395.586 4.502 4.502 0 0 0 0 1.71.5.5 0 0 1-.981.19 5.5 5.5 0 0 1 0-2.09.5.5 0 0 1 .586-.396Zm9.628 0a.5.5 0 0 1 .585.396 5.5 5.5 0 0 1 0 2.09.5.5 0 0 1-.982-.19c.11-.564.11-1.145 0-1.71a.5.5 0 0 1 .397-.586ZM8.39 1.58a.5.5 0 0 1 .694-.133c.584.396 1.086.9 1.48 1.485a.5.5 0 1 1-.83.558 4.5 4.5 0 0 0-1.21-1.215.5.5 0 0 1-.134-.694Zm-5.46-.144a.5.5 0 0 1 .558.83 4.5 4.5 0 0 0-1.215 1.21.5.5 0 0 1-.828-.56c.396-.584.9-1.086 1.486-1.48ZM4.956.6a5.5 5.5 0 0 1 2.09 0 .5.5 0 0 1-.19.982 4.501 4.501 0 0 0-1.71 0A.5.5 0 1 1 4.955.6Z"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconCircleDashed',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
